import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { NewMorphemeLessonLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { View } from "@-/com.npmjs.react-native";

export type LessonPageHeaderTextsVariant = "portrait" | "landscape";

export function LessonPageHeaderTexts({ variant }: { variant: LessonPageHeaderTextsVariant }) {
  const [lessonPart] = useContextSelectors(NewMorphemeLessonLayoutContext, (c) => c.lessonPart);

  const titleBase =
    lessonPart === "pronunciation"
      ? "New Pronunciation"
      : lessonPart === "primitive"
        ? "New Primitive"
        : lessonPart === "meaning"
          ? "New Glyph"
          : "New Character";

  // Explicit `text-foreground` is load-bearing: with only `colorVariant="default"` the title
  // relied on the cva base color, which uniwind drops here once an arbitrary `text-[Npx]` size is
  // in the className — the heading then renders the platform-default black and is invisible on the
  // dark-mode card. Every other large heading in the app re-adds `text-foreground` for the same
  // reason; match that.
  const titleClassName =
    variant === "portrait"
      ? "text-center font-sans text-4xl font-bold text-foreground"
      : "text-center font-sans text-3xl font-bold text-foreground";

  return (
    <View className="shrink-0 items-center py-2" pointerEvents="none">
      <Text className={titleClassName} colorVariant="default">
        {titleBase}
      </Text>
    </View>
  );
}
